<!--组件说明-->
<!--传入值格式-->
<!--Data="{'obj':'depart','data':departmentList,'attr':{'id':'id','children':'children','label':'label','func':父组件方法名，回调参数为子组件修改值-->
<!--                    'show_checkbox':true,'son_only':false,'half':true,'no_connect':true,'title':'执行部门','name':null,'list':null}}-->
<!--obj:对象类型，用来区分写入全局数据-->
<!--data:传入数据列表，必须有主键、名字及子列表字段，可选禁用属性-->
<!--attr:id映射主键，children映射子列表，label映射名字，disabled映射是否禁用，title：选框说明文字，name：默认选中项名字（单选），list：默认选中项id列表（多选） c_priority:是否必填-->
<!--show_checkbox：是否可多选(前提条件)=>，no_connect：是否遵循父子连接关系，son_only：是否只返回最终级id，half：是否包括半选节点(父级)id，-->
<template>
    <div class="mb-2">
        <label class="col-sm-4  text-lr">
            <i  class="fa fa-asterisk text-danger font10 ml-1" aria-hidden="true"></i>
            {{ Data.attr.title }}：</label>
        <span class="col-sm-7">
            <el-badge :value="list.length" :hidden="list.length===0" class="item " type="primary">
               <el-dropdown trigger="click" ref="Dropdown2">
                   <el-button type="primary" size="small">{{ name === undefined || name === '' ? '查看选项' : name }}<i
                           v-if="Data.attr.show_checkbox" class="el-icon-arrow-down el-icon--right"></i>
                    </el-button><i v-if="!Data.attr.show_checkbox" class="el-icon-circle-close ml-2"
                                   @click="clearData()"></i>
                    <el-dropdown-menu slot="dropdown" style="min-width: 300px;max-height: 400px;overflow-y: scroll">
                        <template v-if="checkAll">
                            <el-checkbox 
                                :indeterminate="isIndeterminate" 
                                v-model="isAllSet" 
                                @change="handleCheckAllChange"
                                style="margin-left: 25px; margin-bottom: 2px;"
                            >
                            全选
                            </el-checkbox>
                            <el-divider></el-divider>
                      </template>
                      <el-tree :data="Data.data" :show-checkbox="show_checkbox" @check="set_choice_data(2)"
                               @node-click="set_choice_data(1)" node-key="id" :props="defaultProps"
                               :default-checked-keys="checked_list"
                               ref="tree" class="filter-tree" accordion :check-strictly="Data.attr.no_connect"
                      ></el-tree>
                    </el-dropdown-menu>
                  </el-dropdown>
            </el-badge>
         </span>
    </div>
</template>
<script>
export default {
    name: "select_tree",
    props: [
        'Data',
        "checkAll"
    ],
    data() {
        return {
            commit_flag: this.Data.attr.vuex_commit === undefined ? true : this.Data.attr.vuex_commit,
            name: this.Data.attr.name === null ? this.Data.attr.title : this.Data.attr.name,
            checked_list: this.Data.attr.checked_list,
            value: '',
            list: this.Data.attr.list === null ? [] : this.Data.attr.list,
            show_checkbox: this.Data.attr.show_checkbox,
            defaultProps: {
                id: this.Data.attr.id,
                children: this.Data.attr.children,
                label: this.Data.attr.label,
            },
            isAllSet: false,
            isIndeterminate: false
        }
    },
    mounted() {
        if (this.list.length !== 0) {
            this.$refs.tree.setCheckedKeys(this.list, this.Data.attr.son_only)
        }
    },
    methods: {
        handleCheckAllChange(data) {
            this.$refs.tree.setCheckedKeys(data ? this.Data.data.map(i => i.id) : [])
            this.set_choice_data(2)
        },
        set_choice_data(location) {
            if (location === 1) {
                if (this.show_checkbox) return
                if (this.$refs.tree.getCurrentNode()[this.defaultProps.children] === undefined || this.$refs.tree.getCurrentNode()[this.defaultProps.children] === null || this.$refs.tree.getCurrentNode()[this.defaultProps.children].length === 0) {
                    this.value = this.$refs.tree.getCurrentNode()[this.defaultProps.id]
                    this.name = this.$refs.tree.getCurrentNode()[this.defaultProps.label]
                    this.$refs.Dropdown2.hide()
                    if (this.commit_flag) {
                        this.$get_objects(this.Data, this.value)
                    }
                    if (this.Data.attr.func !== undefined) {
                        console.log('sd656666666')
                        this.$emit(this.Data.attr.func, this.value)
                    }
                }
            } else {
                console.log(this.commit_flag,'03265')
                let temp = this.$refs.tree.getCheckedNodes(this.Data.attr.son_only, this.Data.attr.half)
                this.list = temp.map(item => item.id)
                if (this.commit_flag) {
                    this.$get_objects(this.Data, this.list)
                }
                if (this.Data.attr.func !== undefined) {
                    console.log(this.list,'list')
                    this.$emit(this.Data.attr.func, this.list)
                }
            }

        },
        clearData() {
            this.value = ''
            this.name = this.Data.attr.title
            this.$get_objects(this.Data, [])
            if (this.Data.attr.clear_func !== undefined) {
                this.$emit(this.Data.attr.clear_func)
            }
        },
    }
}
</script>

<style scoped>
.el-divider {
  margin: 5px 0;
}
</style>